var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-popup',{attrs:{"round":_vm.round,"position":"bottom"},model:{value:(_vm.actionSheetShow),callback:function ($$v) {_vm.actionSheetShow=$$v},expression:"actionSheetShow"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }